import AvatarDisplay from "components/avatar/display";
import { formatName } from "utils/index";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "ui/components/tooltip";

export const EmployeeCell = ({ getValue }) => {
  const employee = getValue();
  if (employee == null) return;
  const department = employee.department?.name;
  const grade = employee.grade?.name;
  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <AvatarDisplay className="w-8 h-8" user={employee} />
        </TooltipTrigger>
        <TooltipContent>
          <p className="font-medium">{formatName(employee)}</p>
          {(department || grade) && (
            <p className="text-xs mt-0.5 mx-auto text-center">
              {[department, grade].filter(Boolean).join(" · ")}
            </p>
          )}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};

export const EmployeeUserCell = ({ getValue }) => {
  const user = getValue();
  if (user == null) return;
  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <AvatarDisplay className="w-8 h-8" user={user} />
        </TooltipTrigger>
        <TooltipContent>
          <p>{formatName(user)}</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};
